export class NotificationsSearchModel {
  pageData: Notification[];
  pageIndex: number;
  pageSize: number;
  unSeenNotificationsCount: number;
  totalCount: number;
}
